var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg68(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 48.0078C37.7069 48.0078 48.0078 37.7069 48.0078 25C48.0078 12.2931 37.7069 1.99219 25 1.99219C12.2931 1.99219 1.99219 12.2931 1.99219 25C1.99219 37.7069 12.2931 48.0078 25 48.0078Z",
    fill: "url(#paint0_linear_2460_2757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 31.0742H24.0234V30.9766C25.2539 29.668 26.3672 28.1641 27.5391 26.582L34.0234 17.5586V13.125H27.6172V8.78906H22.2461V13.1445H16.3867V19.0039H25.8594V19.1016C24.6289 20.5664 23.6523 21.7188 22.4219 23.3398L15.625 32.7539V36.9922H22.207V41.2109H27.5781V36.9727H34.375V31.0742Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2757",
    x1: 41.2676,
    y1: 8.73242,
    x2: 8.73242,
    y2: 41.2676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD8421"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg68);
export default __webpack_public_path__ + "static/media/68.0aae30a341ef5816f3f9bb580c17e6fb.svg";
export { ForwardRef as ReactComponent };